import React, { useCallback } from 'react'

import { ImageBox, LinkBlog } from './styles'

import LazyImage from 'components/shared/LazyImage'
import { Button } from 'components/v2/Button'
import { Row } from 'components/v2/Grid'
import { Text } from 'components/v2/Text'
import { Title } from 'components/v2/Title'

const Blog = ({ posts }) => {
	const openLink = useCallback(
		(link) => {
			window.open(link)
		},
		[posts]
	)

	return (
		<section id='news-blog'>
			<Row className='mx-auto max-w-[1200px] flex-wrap px-3 py-16 sm:py-32'>
				<Row className='mb-16 w-full justify-center text-center'>
					<Text className='mb-3 text-base font-semibold text-[#232936] md:text-2xl'>
						Vittude Blog: Fique por dentro
					</Text>
				</Row>

				<Row className='flex-wrap justify-between'>
					{posts.map((post) => (
						<div
							key={post.id}
							onClick={() => openLink(post.link)}
							className='flex w-full min-w-0 cursor-pointer flex-col px-0 md:flex-[0_0_33%] md:!px-5'
						>
							<Title
								type='h3'
								className='text-orange-600 mb-3 text-sm font-semibold'
							>
								{post.category.toUpperCase()}
							</Title>
							<LinkBlog rel='noreferrer' href={post.link} target='_blank'>
								<ImageBox>
									<LazyImage
										style={{ maxWidth: '100%' }}
										src={post.image}
										alt={post.title}
									/>
								</ImageBox>
							</LinkBlog>
							<Text className='mb-6 mt-3 text-sm font-semibold leading-5 text-[#ABAFB6]'>
								{post.date} | {Math.round(post.readTime)} min de leitura
							</Text>
							<LinkBlog rel='noreferrer' href={post.link} target='_blank'>
								<Title
									type='h3'
									variant='dark'
									className='mb-3 text-[18px] font-semibold leading-[120%] text-[#232936]'
								>
									{post.title
										.replace('&#8220;', '\u201C')
										.replace('&#8221;', '\u201D')}
								</Title>
							</LinkBlog>
							<LinkBlog rel='noreferrer' href={post.link} target='_blank'>
								<Text
									variant='small'
									className='text-base leading-5 text-[#232936]'
								>
									{`${post.excerpt
										.replace(/(<([^>]+)>)/gi, '')
										.replace('&#8220;', '\u201C')
										.replace('&#8221;', '\u201D')
										.slice(0, 130)}${
										post.excerpt
											.replace(/(<([^>]+)>)/gi, '')
											.replace('&#8220;', '\u201C')
											.replace('&#8221;', '\u201D').length > 130
											? '...'
											: ''
									}`}
								</Text>
							</LinkBlog>
						</div>
					))}
				</Row>
				<Row className='mt-16 min-w-full flex-wrap justify-center'>
					<a rel='noreferrer' href={`${process.env.VITTUDE_OFFLINE_URL}/blog/`}>
						<Button
							variant='primary-outlined'
							className='h-11 text-sm font-semibold'
						>
							Ver mais no blog
						</Button>
					</a>
				</Row>
			</Row>
		</section>
	)
}

export default Blog
